import React from "react";
import { useLang } from "@/context/LangContext";
import { Reveal } from "@/components/Reveal";
import { useSiteMedia } from "@/context/SiteMediaContext";

const About = () => {
  const { t } = useLang();
  const { media } = useSiteMedia();
  const story = [t("about.story.p1"), t("about.story.p2"), t("about.story.p3")];

  return (
    <div data-testid="about-page">
      {/* Hero */}
      <section className="relative min-h-[62vh] flex items-end bg-[#e8dfd4]">
        <img src={media("about_hero")} alt="Immagine principale Chi siamo" className="absolute inset-0 w-full h-full object-cover object-center" />
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal/65 via-charcoal/10 to-transparent" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 pb-16 w-full">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.25em] text-white/80 mb-5">{t("about.eyebrow")}</p>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl tracking-tight text-white whitespace-pre-line leading-[0.95]">
              {t("about.title")}
            </h1>
          </Reveal>
        </div>
      </section>

      {/* Intro */}
      <section className="max-w-3xl mx-auto px-6 py-24 md:py-32 text-center">
        <Reveal>
          <p className="font-serif text-2xl md:text-3xl text-charcoal leading-snug italic">
            {t("about.intro")}
          </p>
        </Reveal>
      </section>

      {/* Brand story */}
      <section className="grid grid-cols-1 lg:grid-cols-2 items-stretch">
        <div className="relative min-h-[50vh]">
          <img src={media("about_story")} alt="Immagine della storia Kaós" className="absolute inset-0 w-full h-full object-cover object-[60%_center]" />
        </div>
        <div className="bg-champagne-soft px-6 md:px-16 py-20 flex flex-col justify-center">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.25em] text-stone-500 mb-5">Kaós Luxury Cosmetics®</p>
            <h2 className="font-serif text-3xl md:text-4xl text-charcoal">{t("about.story.title")}</h2>
          </Reveal>
          <div className="mt-8 space-y-6 max-w-xl">
            {story.map((paragraph, i) => (
              <Reveal key={i} delay={(i + 1) * 100}>
                <p className="text-stone-600 leading-relaxed">{paragraph}</p>
              </Reveal>
            ))}
            <Reveal delay={400}>
              <p className="font-welcome text-2xl md:text-3xl text-charcoal pt-2">{t("about.story.welcome")}</p>
            </Reveal>
            <Reveal delay={500}>
              <p className="font-signature text-5xl md:text-6xl text-charcoal pt-3 -rotate-2">Marika</p>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
